import { PersonDetails } from '@weave/schema-gen-ts/dist/schemas/forms-digital/weave_digital_forms.pb';
import { createShallowStore, createStore } from '@frontend/store';
import { PostalCodeLocale } from '@frontend/design-system';
import { DEFAULT_POSTAL_CODE_LOCALE } from '../constants';

// TODO: Check all these props are used or not
type State = {
  postalCodeLocale: PostalCodeLocale;
  isPostalCodeLocaleRestored: boolean;
  person?: PersonDetails;
  submissionToken?: string;
  locationId?: string;
  previewMode?: boolean;
};

type Actions = {
  updatePostalCodeLocale: (postalCodeLocale: PostalCodeLocale) => void;
  restorePostalCodeLocale: (postalCodeLocale: PostalCodeLocale) => void;
  clearRestoredPostalCodeLocale: () => void;
  setPerson: (person: PersonDetails | undefined) => void;
};

const initialState: State = {
  postalCodeLocale: DEFAULT_POSTAL_CODE_LOCALE,
  isPostalCodeLocaleRestored: false,
};

type ConfigStore = State & Actions;

const useStore = createStore<ConfigStore>(
  (set) => ({
    ...initialState,
    updatePostalCodeLocale: (postalCodeLocale) => set({ postalCodeLocale }),
    restorePostalCodeLocale: (postalCodeLocale) => set({ postalCodeLocale, isPostalCodeLocaleRestored: true }),
    clearRestoredPostalCodeLocale: () => set({ isPostalCodeLocaleRestored: false }),
    setPerson: (person: PersonDetails | undefined) => set({ person }),
  }),
  { name: 'ConfigStore', trace: true }
);

export const useConfigShallowStore = createShallowStore(useStore);
